import React from 'react';
import { Link } from 'react-router-dom';
import Slider from 'react-slick';
import Banner1 from '../../../assets/images/banner-1.jpg';
import Banner2 from '../../../assets/images/banner-2.jpg';
import Banner3 from '../../../assets/images/banner-3.jpg';
import Banner4 from '../../../assets/images/banner-4.png';

const settings = {
  dots: true,
  infinite: true,
  speed: 500,
  slidesToShow: 1,
  slidesToScroll: 1,
};

const MainSlider = () => {

  settings.nextArrow = <SampleNextArrow />;
  settings.prevArrow = <SamplePrevArrow />;
  return (
    <div className="main-slider">
      <Slider {...settings}>
        <div>
          {/* <img src={Banner1}/> */}
          <div className="background" style={{ backgroundImage: 'url(' + Banner1 + ')' }}></div>
          <div className="slider-content">

            <h1>Alcohol Delivery in 30 Mins<br />or Less Around Downtown LA!</h1>
            <p>Great Prices On All Alcohol Shipped To Your Door</p>
            <div className="cta">
              <p>OPEN UNTIL 2AM DAILY</p>
              <Link to="/products?department=WINES" className="featured-button">CLICK TO START SHOPPING!</Link>
            </div>
          </div>
        </div>
        <div>
          <div className="background" style={{ backgroundImage: 'url(' + Banner2 + ')' }}></div>
          {/* <img src={Banner2}/> */}
          <div className="slider-content">
            <h1>Alcohol Delivery in 30 Mins<br />or Less Around Downtown LA!</h1>
            <p>Great Prices On All Alcohol Shipped To Your Door</p>
            <div className="cta">
              <p>OPEN UNTIL 2AM DAILY</p>
              <Link to="/products?department=BEER" className="featured-button">CLICK TO START SHOPPING!</Link>
            </div>

          </div>
        </div>
        <div>
          <div className="background" style={{ backgroundImage: 'url(' + Banner3 + ')' }}></div>
          {/* <img src={Banner3}/> */}
          <div className="slider-content">
            <h1>Alcohol Delivery in 30 Mins<br />or Less Around Downtown LA!</h1>
            <p>Great Prices On All Alcohol Shipped To Your Door</p>
            <div className="cta">
              <p>OPEN UNTIL 2AM DAILY</p>
              <Link to="/products?department=LIQUOR" className="featured-button">CLICK TO START SHOPPING!</Link>
            </div>
          </div>
        </div>
      </Slider>
    </div>
  )

  function SampleNextArrow(props) {
    const { className, style, onClick } = props
    return (
      <div className={className} style={{
        ...style,
        display: 'block',
        background: 'red'
      }} onClick={onClick}></div>
    );
  }

  function SamplePrevArrow(props) {
    const { className, style, onClick } = props
    return (
      <div className={className} style={{
        ...style,
        display: 'block',
        background: 'green'
      }} onClick={onClick}></div>
    );
  }

}

export default MainSlider;



// WEBPACK FOOTER //
// ./src/components/home/slider/MainSlider.js